import { render } from "./NotApprovedUserMessage.vue?vue&type=template&id=0e74366a&scoped=true"
import script from "./NotApprovedUserMessage.vue?vue&type=script&lang=js"
export * from "./NotApprovedUserMessage.vue?vue&type=script&lang=js"

import "./NotApprovedUserMessage.vue?vue&type=style&index=0&id=0e74366a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e74366a"]])

export default __exports__